/*!
 * @oarepo/vue-taxonomy-editor v1.2.10
 * (c) bauer@cesnet.cz
 */
import _regeneratorRuntime from '@babel/runtime-corejs2/regenerator';
import 'core-js/modules/es6.object.assign';
import 'regenerator-runtime/runtime';
import _asyncToGenerator from '@babel/runtime-corejs2/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime-corejs2/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs2/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime-corejs2/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs2/helpers/getPrototypeOf';
import _inherits from '@babel/runtime-corejs2/helpers/inherits';
import _applyDecoratedDescriptor from '@babel/runtime-corejs2/helpers/applyDecoratedDescriptor';
import { Component, Vue, Watch, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import 'core-js/modules/es6.promise';
import 'core-js/modules/es6.object.to-string';
import 'core-js/modules/es6.regexp.constructor';
import LiquorTree from 'liquor-tree';
import 'core-js/modules/es6.array.find';
import axios from 'axios';

var _dec, _class, _temp;
var DefaultEditDialogComponent = (_dec = Component({
  props: {
    taxonomyNode: Object
  }
}), _dec(_class = (_temp =
/*#__PURE__*/
function (_Vue) {
  _inherits(DefaultEditDialogComponent, _Vue);

  function DefaultEditDialogComponent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DefaultEditDialogComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DefaultEditDialogComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.title = '';
    return _this;
  }

  _createClass(DefaultEditDialogComponent, [{
    key: "show",
    value: function show() {
      console.log('Node to edit:', this.taxonomyNode);

      if (this.taxonomyNode) {
        this.title = this.taxonomyNode.title._;
      }

      this.$refs.dialog.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$refs.dialog.hide();
    }
  }, {
    key: "onDialogHide",
    value: function onDialogHide() {
      this.$emit('hide');
    }
  }, {
    key: "onOKClick",
    value: function onOKClick() {
      this.$emit('ok', {
        title: {
          _: this.title
        },
        // keep slug if set on taxonomyNode
        slug: (this.taxonomyNode ? this.taxonomyNode.slug : null) || this.title,
        // keep extra data if set on taxonomyNode
        extra_data: (this.taxonomyNode ? this.taxonomyNode.extra_data : null) || {}
      });
      this.hide();
    }
  }, {
    key: "onCancelClick",
    value: function onCancelClick() {
      this.hide();
    }
  }]);

  return DefaultEditDialogComponent;
}(Vue), _temp)) || _class);

/* script */
var __vue_script__ = DefaultEditDialogComponent;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('q-dialog', {
    ref: "dialog",
    on: {
      "hide": _vm.onDialogHide
    }
  }, [_c('q-card', {
    staticClass: "q-dialog-plugin"
  }, [_c('q-card-section', [_c('div', {
    staticClass: "text-h6 q-mb-lg"
  }, [_vm._v("Adding new top-level node")]), _vm._v(" "), _c('q-input', {
    attrs: {
      "label": "Node name",
      "focused": ""
    },
    model: {
      value: _vm.title,
      callback: function callback($$v) {
        _vm.title = $$v;
      },
      expression: "title"
    }
  })], 1), _vm._v(" "), _c('q-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('q-btn', {
    attrs: {
      "flat": "",
      "color": "primary",
      "label": "OK"
    },
    on: {
      "click": _vm.onOKClick
    }
  }), _vm._v(" "), _c('q-btn', {
    attrs: {
      "flat": "",
      "label": "Cancel"
    },
    on: {
      "click": _vm.onCancelClick
    }
  })], 1)], 1)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var _dec$1, _dec2, _class$1, _class2, _temp$1;
var TaxonomyMixin = (_dec$1 = Component({
  components: {
    'tree': LiquorTree
  },
  props: {
    'taxonomyUrl': String,
    'taxonomyCode': String,
    'filterMatcher': Function
  }
}), _dec2 = Watch('taxonomyUrl'), _dec$1(_class$1 = (_class2 = (_temp$1 =
/*#__PURE__*/
function (_Vue) {
  _inherits(TaxonomyMixin, _Vue);

  function TaxonomyMixin() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TaxonomyMixin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TaxonomyMixin)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.filter = '';
    _this.filterOptions = {
      emptyText: 'Nothing found!',
      matcher: function matcher(query, node) {
        if (_this.filterMatcher) {
          return _this.filterMatcher({
            taxonomyCode: _this.taxonomyCode,
            query: query,
            term: node.data
          });
        }

        var val = JSON.stringify(node.data);
        console.log('filter', query, val);
        return new RegExp(query, 'i').test(val);
      },
      plainList: false,
      showChildren: true
    };
    _this.data = [];
    _this.dataReady = false;
    _this.localTaxonomyUrl = null;
    _this.parentTaxonomyUrl = null;
    _this.subtree = null;
    return _this;
  }

  _createClass(TaxonomyMixin, [{
    key: "mounted",
    value: function mounted() {
      this.onTaxonomyUrl();
    }
  }, {
    key: "processData",
    value: function processData(data) {
      var _this2 = this;

      return data.map(function (x) {
        if (x.children !== undefined) {
          x.children = _this2.processData(x.children);
        }

        x.data = Object.assign({}, x);

        if (x.data.selectable !== undefined) {
          x.state = {
            selectable: x.data.selectable
          };
        }

        delete x.data.children;
        return x;
      });
    }
  }, {
    key: "onTaxonomyUrl",
    value: function onTaxonomyUrl() {
      console.log('taxonomy url', this.taxonomyUrl);

      if (this.taxonomyUrl !== undefined) {
        this.localTaxonomyUrl = this.taxonomyUrl;
        this.loadTaxonomy().then(function () {});
      }
    }
  }, {
    key: "loadTaxonomy",
    value: function loadTaxonomy() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.dataReady = false;
        console.log('loading taxonomy', _this3.localTaxonomyUrl);

        if (_this3.localTaxonomyUrl !== null) {
          _this3.$axios.get(_this3.localTaxonomyUrl, {
            headers: {
              'Accept': 'application/json; drilldown=true'
            }
          }).then(function (data) {
            if (Array.isArray(data.data)) {
              _this3.data = _this3.processData(data.data);
              _this3.parentTaxonomyUrl = null;
              _this3.subtree = null;
            } else {
              _this3.parentTaxonomyUrl = data.data.links.parent_tree || null;
              _this3.data = _this3.processData(data.data.children);
              _this3.subtree = data.data;
            }

            _this3.$nextTick(function () {
              _this3.dataReady = true;
            });

            resolve();
          }).catch(function () {
            resolve();
          });
        } else {
          _this3.data = [];
          resolve();
        }
      });
    }
  }, {
    key: "openTaxonomy",
    value: function openTaxonomy(node) {
      this.localTaxonomyUrl = node.data.links.tree;
      this.loadTaxonomy().then(function () {});
    }
  }, {
    key: "taxonomyUp",
    value: function taxonomyUp() {
      this.localTaxonomyUrl = this.parentTaxonomyUrl;
      this.loadTaxonomy().then(function () {});
    }
  }]);

  return TaxonomyMixin;
}(Vue), _temp$1), (_applyDecoratedDescriptor(_class2.prototype, "onTaxonomyUrl", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "onTaxonomyUrl"), _class2.prototype)), _class2)) || _class$1);

var _dec$2, _class$2;
var DefaultViewComponent = (_dec$2 = Component({
  props: {
    taxonomyCode: String,
    term: Object
  }
}), _dec$2(_class$2 =
/*#__PURE__*/
function (_Vue) {
  _inherits(DefaultViewComponent, _Vue);

  function DefaultViewComponent() {
    _classCallCheck(this, DefaultViewComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultViewComponent).apply(this, arguments));
  }

  return DefaultViewComponent;
}(Vue)) || _class$2);

/* script */
var __vue_script__$1 = DefaultViewComponent;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', [_vm._v("\n" + _vm._s(_vm.term.title) + "\n")]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = __vue_normalize__({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var _dec$3, _dec2$1, _dec3, _class$3, _class2$1, _temp$2;
var TaxonomyEditor = (_dec$3 = Component({
  name: 'taxonomy-editor',
  props: {
    'editDialogComponent': [Object, Function]
  }
}), _dec2$1 = Watch('treeSort.order'), _dec3 = Watch('treeSort.recursive'), _dec$3(_class$3 = (_class2$1 = (_temp$2 =
/*#__PURE__*/
function (_mixins) {
  _inherits(TaxonomyEditor, _mixins);

  function TaxonomyEditor() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TaxonomyEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TaxonomyEditor)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.filter = '';
    _this.treeSort = {
      recursive: false,
      order: 'asc'
    };
    return _this;
  }

  _createClass(TaxonomyEditor, [{
    key: "changeTreeOrder",
    value: function changeTreeOrder() {
      this.sortTree();
    }
  }, {
    key: "changeTreeRecursiveSort",
    value: function changeTreeRecursiveSort() {
      this.sortTree();
    }
  }, {
    key: "onTreeMounted",
    value: function onTreeMounted() {
      window.t = this.$refs.tree;
      this.sortTree();
    }
  }, {
    key: "titleSort",
    value: function titleSort(node0, node1) {
      return new Intl.Collator(node0.data.title[0].lang).compare(node0.data.title[0].value, node1.data.title[0].value);
    }
  }, {
    key: "sortTree",
    value: function sortTree() {
      if (this.$refs.tree) {
        this.$refs.tree.sortTree(this.titleSort, this.treeSort.recursive);
      }
    }
  }, {
    key: "editNode",
    value: function editNode(node) {
      var _this2 = this;

      this.$q.dialog({
        component: this.editComponent,
        taxonomyNode: node.data,
        persistent: true
      }).onOk(function (data) {
        _this2.$axios.patch(node.data.links.self, data).then(function (data) {
          node.data = data.data;

          _this2.sortTree();
        });
      });
    }
  }, {
    key: "removeNode",
    value: function removeNode(node) {
      var _this3 = this;

      this.$q.dialog({
        title: 'Deleting taxonomy term',
        message: 'Do you really want to delete taxonomy term?',
        cancel: true,
        persistent: true
      }).onOk(function () {
        _this3.$axios.delete(node.data.links.self).then(function () {
          node.remove();

          _this3.sortTree();
        }).catch(function (error) {
          if (error.response.status === 409) {
            var recnum = error.response.data.message.records.length;
            console.log(recnum);

            _this3.$q.notify({
              message: "Tento pojem je pou\u017Eit ve ".concat(recnum, " existuj\xEDc\xEDch z\xE1znamech.") + 'Odeberte jej prosím nejdříve z těchto záznamů',
              color: 'red',
              position: 'center',
              icon: 'block'
            });
          } else {
            console.log('failed to delete term');
          }
        });
      });
    }
  }, {
    key: "addChildNode",
    value: function addChildNode(node) {
      var _this4 = this;

      this.$q.dialog({
        component: this.editComponent,
        persistent: true
      }).onOk(function (data) {
        _this4.$axios.post(node.data.links.self, data).then(function (data) {
          // add to the child node
          _this4.$refs.tree.append(node, {
            data: data.data
          });

          node.expand();

          _this4.sortTree();
        });
      });
    }
  }, {
    key: "addNode",
    value: function addNode() {
      var _this5 = this;

      this.$q.dialog({
        component: this.editComponent,
        persistent: true
      }).onOk(function (data) {
        _this5.$axios.post(_this5.localTaxonomyUrl, data).then(function (data) {
          // add the node top-level
          _this5.$refs.tree.append({
            data: data.data
          });

          _this5.sortTree();
        });
      });
    }
  }, {
    key: "dragStart",
    value: function dragStart(node) {}
  }, {
    key: "dragFinish",
    value: function dragFinish(node, targetNode, dropPosition) {
      this.$axios.post(node.data.links.self, '', {
        headers: {
          'Destination': targetNode.data.links.self,
          'Destination-Order': {
            'drag-on': 'inside',
            'drag-above': 'before',
            'drag-below': 'after'
          }[dropPosition],
          'Content-Type': 'application/vnd.move'
        }
      }).then(function (resp) {
        console.log('Dragging finished', resp);
      });
    }
  }, {
    key: "opts",
    get: function get() {
      return {
        // minFetchDelay: 1000,
        // fetchData: node => Promise.resolve(this.data[node.id - 1]),
        checkbox: false,
        dnd: true,
        filter: this.filterOptions
      };
    }
  }, {
    key: "editComponent",
    get: function get() {
      return this.editDialogComponent || this.$taxonomies.editors[this.taxonomyCode] || __vue_component__;
    }
  }, {
    key: "viewComponent",
    get: function get() {
      return this.$taxonomies.viewers[this.taxonomyCode] || this.$taxonomies.defaultViewer || __vue_component__$1;
    }
  }]);

  return TaxonomyEditor;
}(mixins(TaxonomyMixin)), _temp$2), (_applyDecoratedDescriptor(_class2$1.prototype, "changeTreeOrder", [_dec2$1], Object.getOwnPropertyDescriptor(_class2$1.prototype, "changeTreeOrder"), _class2$1.prototype), _applyDecoratedDescriptor(_class2$1.prototype, "changeTreeRecursiveSort", [_dec3], Object.getOwnPropertyDescriptor(_class2$1.prototype, "changeTreeRecursiveSort"), _class2$1.prototype)), _class2$1)) || _class$3);

/* script */
var __vue_script__$2 = TaxonomyEditor;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tree"
  }, [_c('div', {
    staticClass: "buttons row"
  }, [_vm._t("buttons-left"), _vm._v(" "), _c('q-btn', {
    attrs: {
      "icon": "expand_more",
      "flat": "",
      "color": "primary",
      "dense": "",
      "title": "expand all"
    },
    on: {
      "click": function click($event) {
        _vm.$refs.tree.findAll({}).expand();
      }
    }
  }), _vm._v(" "), _c('q-btn', {
    attrs: {
      "icon": "expand_less",
      "flat": "",
      "color": "primary",
      "dense": "",
      "title": "collapse all"
    },
    on: {
      "click": function click($event) {
        _vm.$refs.tree.findAll({}).collapse();
      }
    }
  }), _vm._v(" "), _vm._t("buttons-middle"), _vm._v(" "), _vm.parentTaxonomyUrl ? _c('q-btn', {
    staticClass: "rotate-90",
    attrs: {
      "icon": "subdirectory_arrow_left",
      "flat": "",
      "color": "primary",
      "dense": "",
      "title": "Taxonomy up"
    },
    on: {
      "click": function click($event) {
        return _vm.taxonomyUp();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.subtree ? _c('div', {
    staticClass: "title q-mt-sm q-ml-md"
  }, [_vm._t("title", [_c(_vm.viewComponent, {
    tag: "component",
    attrs: {
      "taxonomy-code": _vm.taxonomyCode,
      "term": _vm.subtree
    }
  })], {
    "subtree": _vm.subtree
  })], 2) : _vm._e(), _vm._v(" "), _vm._t("buttons-right"), _vm._v(" "), _c('q-space'), _vm._v(" "), _c('q-input', {
    staticClass: "q-mr-lg print-hide",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_vm.filter !== '' ? _c('q-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "name": "close"
          },
          on: {
            "click": function click($event) {
              _vm.filter = '';
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('q-icon', {
          attrs: {
            "name": "search"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  })], 2), _vm._v(" "), _vm.dataReady ? _c('tree', {
    ref: "tree",
    attrs: {
      "data": _vm.data,
      "options": _vm.opts,
      "filter": _vm.filter
    },
    on: {
      "tree:mounted": _vm.onTreeMounted,
      "node:dragging:start": _vm.dragStart,
      "node:dragging:finish": _vm.dragFinish
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var node = ref.node;
        return _c('div', {
          staticClass: "node-container full-width"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col"
        }, [_vm._t("item-" + (_vm.taxonomyCode || 'default'), [_vm._t("item", [_c('div', {
          staticClass: "node-text"
        }, [_c(_vm.viewComponent, {
          tag: "component",
          attrs: {
            "taxonomy-code": _vm.taxonomyCode,
            "term": node.data
          }
        })], 1)], {
          "item": node.data
        })], {
          "item": node.data
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "node-controls"
        }, [_c('q-btn', {
          attrs: {
            "href": "#",
            "flat": "",
            "icon": "edit",
            "size": "sm",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.editNode(node);
            }
          }
        }), _vm._v(" "), _c('q-btn', {
          attrs: {
            "href": "#",
            "flat": "",
            "icon": "playlist_add",
            "size": "sm",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.addChildNode(node);
            }
          }
        }), _vm._v(" "), node.data.descendants_count > 0 ? _c('q-btn', {
          attrs: {
            "href": "#",
            "flat": "",
            "icon": "fullscreen",
            "size": "sm",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.openTaxonomy(node);
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('q-btn', {
          attrs: {
            "href": "#",
            "flat": "",
            "icon": "remove",
            "size": "sm",
            "color": "red"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.removeNode(node);
            }
          }
        })], 1)])]);
      }
    }], null, true)
  }) : _vm._e()], 1), _vm._v(" "), _c('q-btn', {
    staticClass: "print-hide",
    attrs: {
      "round": "",
      "icon": "add",
      "color": "primary"
    },
    on: {
      "click": _vm.addNode
    }
  })], 1);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = "data-v-6b346176";
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = __vue_normalize__({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

var _dec$4, _dec2$2, _class$4, _class2$2, _temp$3;
var DialogTaxonomyInputDialog = (_dec$4 = Component({
  props: {
    value: Array,
    multiple: Boolean
  }
}), _dec2$2 = Watch('value'), _dec$4(_class$4 = (_class2$2 = (_temp$3 =
/*#__PURE__*/
function (_mixins) {
  _inherits(DialogTaxonomyInputDialog, _mixins);

  function DialogTaxonomyInputDialog() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DialogTaxonomyInputDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DialogTaxonomyInputDialog)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.selectedTerms = [];
    _this.filter = '';
    _this.treeSort = {
      recursive: false,
      order: 'asc'
    };
    return _this;
  }

  _createClass(DialogTaxonomyInputDialog, [{
    key: "titleSort",
    value: function titleSort(node0, node1) {
      return new Intl.Collator(node0.data.title[0].lang).compare(node0.data.title[0].value, node1.data.title[0].value);
    }
  }, {
    key: "sortTree",
    value: function sortTree() {
      if (this.$refs.tree) {
        this.$refs.tree.sortTree(this.titleSort, this.treeSort.recursive);
      }
    }
  }, {
    key: "valueChanged",
    value: function valueChanged() {
      this.sortTree();
      this.selectedTerms = this.value || [];
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.valueChanged();
    }
  }, {
    key: "show",
    value: function show() {
      this.$refs.dialog.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$refs.dialog.hide();
    }
  }, {
    key: "onDialogHide",
    value: function onDialogHide() {
      this.$emit('hide');
    }
  }, {
    key: "onDialogShow",
    value: function onDialogShow() {
      var _this2 = this;

      this.sortTree();

      if (this.multiple && this.selectedTerms) {
        this.selectedTerms.forEach(function (term) {
          var selection = _this2.$refs.tree.find({
            data: {
              id: term.id
            }
          });

          if (selection) {
            selection.check();
          }
        });
      }
    }
  }, {
    key: "onOKClick",
    value: function onOKClick() {
      this.$emit('ok', this.selectedTerms);
      this.hide();
    }
  }, {
    key: "onCancelClick",
    value: function onCancelClick() {
      this.hide();
    }
  }, {
    key: "singleValueClick",
    value: function singleValueClick(term) {
      if (term.children.length > 0) {
        return;
      }

      if (this.multiple) {
        return;
      }

      this.selectedTerms = [term.data];
      this.onOKClick();
    }
  }, {
    key: "singleValueSelected",
    value: function singleValueSelected(term) {
      if (this.multiple) {
        return;
      }

      this.selectedTerms = [term.data];

      if (!this.multiple) {
        this.onOKClick();
      }
    }
  }, {
    key: "multipleValuesSelected",
    value: function multipleValuesSelected() {
      if (this.$refs.tree) {
        var foundTerms = this.$refs.tree.findAll({
          state: {
            checked: true
          }
        });

        if (foundTerms !== null) {
          this.selectedTerms = foundTerms.map(function (x) {
            return x.data;
          });
        } else {
          this.selectedTerms = [];
        }
      }

      this.onOKClick();
    }
  }, {
    key: "opts",
    get: function get() {
      return {
        checkbox: true,
        filter: this.filterOptions,
        autoCheckChildren: false
      };
    }
  }, {
    key: "viewComponent",
    get: function get() {
      return this.$taxonomies.viewers[this.taxonomyCode] || this.$taxonomies.defaultViewer || __vue_component__$1;
    }
  }]);

  return DialogTaxonomyInputDialog;
}(mixins(TaxonomyMixin)), _temp$3), (_applyDecoratedDescriptor(_class2$2.prototype, "valueChanged", [_dec2$2], Object.getOwnPropertyDescriptor(_class2$2.prototype, "valueChanged"), _class2$2.prototype)), _class2$2)) || _class$4);

/* script */
var __vue_script__$3 = DialogTaxonomyInputDialog;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('q-dialog', {
    ref: "dialog",
    on: {
      "hide": _vm.onDialogHide,
      "show": _vm.onDialogShow
    }
  }, [_c('q-card', {
    staticClass: "q-dialog-plugin",
    staticStyle: {
      "width": "700px",
      "max-width": "80vw",
      "height": "80vw"
    }
  }, [_c('q-card-section'), _vm._v(" "), _c('q-card-section', [_c('div', {
    staticClass: "buttons row"
  }, [_vm._t("buttons-left"), _vm._v(" "), _c('q-btn', {
    attrs: {
      "icon": "expand_more",
      "flat": "",
      "color": "primary",
      "dense": "",
      "title": "expand all"
    },
    on: {
      "click": function click($event) {
        _vm.$refs.tree.findAll({}).expand();
      }
    }
  }), _vm._v(" "), _c('q-btn', {
    attrs: {
      "icon": "expand_less",
      "flat": "",
      "color": "primary",
      "dense": "",
      "title": "collapse all"
    },
    on: {
      "click": function click($event) {
        _vm.$refs.tree.findAll({}).collapse();
      }
    }
  }), _vm._v(" "), _vm._t("buttons-middle"), _vm._v(" "), _vm.parentTaxonomyUrl ? _c('q-btn', {
    staticClass: "rotate-90",
    attrs: {
      "icon": "subdirectory_arrow_left",
      "flat": "",
      "color": "primary",
      "dense": "",
      "title": "Taxonomy up"
    },
    on: {
      "click": function click($event) {
        return _vm.taxonomyUp();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.subtree ? _c('div', {
    staticClass: "title q-mt-sm q-ml-md"
  }, [_vm._t("title", [_c(_vm.viewComponent, {
    tag: "component",
    attrs: {
      "taxonomy-code": _vm.taxonomyCode,
      "term": _vm.subtree
    }
  })], {
    "subtree": _vm.subtree
  })], 2) : _vm._e(), _vm._v(" "), _vm._t("buttons-right"), _vm._v(" "), _c('q-space'), _vm._v(" "), _c('q-input', {
    staticClass: "q-mr-lg",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_vm.filter !== '' ? _c('q-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "name": "close"
          },
          on: {
            "click": function click($event) {
              _vm.filter = '';
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('q-icon', {
          attrs: {
            "name": "search"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _vm._v(" "), _vm.multiple ? _c('q-btn', {
    attrs: {
      "icon": "check",
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": _vm.multipleValuesSelected
    }
  }, [_vm._v(" OK\n                    ")]) : _vm._e()], 2), _vm._v(" "), _c('q-separator'), _vm._v(" "), _vm.dataReady ? _c('tree', {
    ref: "tree",
    attrs: {
      "data": _vm.data,
      "options": _vm.opts,
      "filter": _vm.filter
    },
    on: {
      "node:clicked": _vm.singleValueClick,
      "node:checked": _vm.singleValueSelected
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var node = ref.node;
        return _c('div', {
          staticClass: "node-container full-width"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col"
        }, [_vm._t("item", [_c('div', {
          staticClass: "node-text"
        }, [_c(_vm.viewComponent, {
          tag: "component",
          attrs: {
            "taxonomy-code": _vm.taxonomyCode,
            "term": node.data
          }
        })], 1)], {
          "item": node.data
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "node-controls"
        }, [node.data.descendants_count > 0 ? _c('q-btn', {
          attrs: {
            "href": "#",
            "flat": "",
            "icon": "fullscreen",
            "size": "sm",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.openTaxonomy(node);
            }
          }
        }) : _vm._e()], 1)])]);
      }
    }], null, true)
  }) : _vm._e()], 1)], 1)], 1)], 1);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = "data-v-4ab26371";
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = __vue_normalize__({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

var _dec$5, _dec2$3, _dec3$1, _class$5, _class2$3, _temp$4;
var DialogTaxonomyInput = (_dec$5 = Component({
  props: {
    label: String,
    inline: Boolean,
    multiple: Boolean,
    value: [Object, Array],
    rules: Array,
    lazyRules: Array
  }
}), _dec2$3 = Watch('value'), _dec3$1 = Emit('input'), _dec$5(_class$5 = (_class2$3 = (_temp$4 =
/*#__PURE__*/
function (_mixins) {
  _inherits(DialogTaxonomyInput, _mixins);

  function DialogTaxonomyInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DialogTaxonomyInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DialogTaxonomyInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.selectedTerms = [];
    _this.filter = '';
    return _this;
  }

  _createClass(DialogTaxonomyInput, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.setInitialValue();
      this.$nextTick(function () {
        _this2.resetValidation();
      });
    }
  }, {
    key: "resetValidation",
    value: function resetValidation() {
      var _this3 = this;

      if (this.$refs.field) {
        this.$refs.field.resetValidation();
      } else {
        this.$nextTick(function () {
          _this3.resetValidation();
        });
      }
    }
  }, {
    key: "setInitialValue",
    value: function setInitialValue() {
      if (this.multiple) {
        if (!this.value) {
          this.selectedTerms = [];
        } else {
          this.selectedTerms = this.value;
        }
      } else {
        if (this.value) {
          this.selectedTerms = [this.value];
        } else {
          this.selectedTerms = [];
        }
      }
    }
  }, {
    key: "showSelectionDialog",
    value: function showSelectionDialog() {
      var _this4 = this;

      this.loadTaxonomy().then(function () {
        _this4.selectorShown = true;

        _this4.$q.dialog({
          component: __vue_component__$3,
          value: _this4.selectedTerms,
          taxonomyUrl: _this4.taxonomyUrl,
          taxonomyCode: _this4.taxonomyCode,
          filterMatcher: _this4.filterMatcher,
          multiple: _this4.multiple
        }).onOk(function (terms) {
          _this4.selectedTerms = terms;

          _this4.validateAndEmit();
        });
      });
    }
  }, {
    key: "removeSelected",
    value: function removeSelected(term) {
      this.selectedTerms = this.selectedTerms.filter(function (x) {
        return x.links.self !== term.links.self;
      });
      this.validateAndEmit();
    }
  }, {
    key: "emit",
    value: function emit() {
      if (this.multiple) {
        return this.selectedTerms;
      } else {
        if (this.selectedTerms.length > 0) {
          return this.selectedTerms[0];
        }

        return null;
      }
    }
  }, {
    key: "validate",
    value: function validate(val) {
      return this.$refs.field.validate(val);
    }
  }, {
    key: "validateAndEmit",
    value: function validateAndEmit() {
      var _this5 = this;

      this.$nextTick(function () {
        // validate and emit in the next tick as the selectedTerms has to propagate to qfield in order
        // to be validated
        Promise.resolve(_this5.validate()).then(function (status) {
          if (status) {
            _this5.emit();
          }
        });
      });
    }
  }, {
    key: "opts",
    get: function get() {
      return {
        checkbox: true,
        filter: this.filterOptions,
        autoCheckChildren: false
      };
    }
  }, {
    key: "viewComponent",
    get: function get() {
      return this.$taxonomies.viewers[this.taxonomyCode] || this.$taxonomies.defaultViewer || __vue_component__$1;
    }
  }, {
    key: "internalValidationValue",
    get: function get() {
      if (this.multiple) {
        return this.selectedTerms;
      }

      if (this.selectedTerms.length) {
        return this.selectedTerms[0];
      }

      return null;
    }
  }, {
    key: "error",
    get: function get() {
      return this.$refs.field.error;
    }
  }]);

  return DialogTaxonomyInput;
}(mixins(TaxonomyMixin)), _temp$4), (_applyDecoratedDescriptor(_class2$3.prototype, "setInitialValue", [_dec2$3], Object.getOwnPropertyDescriptor(_class2$3.prototype, "setInitialValue"), _class2$3.prototype), _applyDecoratedDescriptor(_class2$3.prototype, "emit", [_dec3$1], Object.getOwnPropertyDescriptor(_class2$3.prototype, "emit"), _class2$3.prototype)), _class2$3)) || _class$5);

/* script */
var __vue_script__$4 = DialogTaxonomyInput;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('q-field', {
    ref: "field",
    attrs: {
      "label": _vm.label,
      "value": _vm.internalValidationValue,
      "rules": this.rules,
      "lazy-rules": _vm.lazyRules,
      "stack-label": ""
    },
    nativeOn: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.showSelectionDialog();
      }
    },
    scopedSlots: _vm._u([{
      key: "control",
      fn: function fn() {
        return [_c('div', {
          staticClass: "self-center full-width no-outline",
          attrs: {
            "tabindex": "0"
          }
        }, _vm._l(_vm.selectedTerms, function (selected) {
          return _c('div', {
            key: selected.links.self,
            class: {
              'inline-term': _vm.inline
            }
          }, [_vm._t("selected-item-wrapper", [_vm.multiple ? [_c('q-chip', {
            attrs: {
              "outline": "",
              "removable": "",
              "color": "primary"
            },
            on: {
              "remove": function remove($event) {
                return _vm.removeSelected(selected);
              }
            }
          }, [_vm._t("selected-item-multiple", [_vm._t("selected-item", [_vm._t("item", [_c(_vm.viewComponent, {
            tag: "component",
            attrs: {
              "taxonomy-code": _vm.taxonomyCode,
              "term": selected
            }
          })], {
            "item": selected
          })], {
            "item": selected
          })], {
            "item": selected
          })], 2)] : [_vm._t("selected-item-single", [_vm._t("selected-item", [_vm._t("item", [_c(_vm.viewComponent, {
            tag: "component",
            attrs: {
              "taxonomy-code": _vm.taxonomyCode,
              "term": selected
            }
          })], {
            "item": selected
          })], {
            "item": selected
          })], {
            "item": selected
          })]], {
            "item": selected
          })], 2);
        }), 0)];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [!_vm.multiple && _vm.selectedTerms.length ? _c('q-btn', {
          attrs: {
            "flat": "",
            "icon": "close",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.removeSelected(_vm.selectedTerms[0]);
            }
          }
        }) : _vm._e(), _vm._v(" "), _vm.multiple || !_vm.selectedTerms.length ? _c('q-btn', {
          attrs: {
            "flat": "",
            "icon": "fas fa-hand-pointer",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.showSelectionDialog();
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, true)
  })], 1);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = "data-v-135d63e2";
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = __vue_normalize__({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var Taxonomies =
/*#__PURE__*/
function () {
  function Taxonomies() {
    _classCallCheck(this, Taxonomies);

    this.taxonomies = {};
    this.viewers = {};
    this.editors = {};
    this.defaultViewer = null;
  }

  _createClass(Taxonomies, [{
    key: "addTaxonomy",
    value: function addTaxonomy(code, title, url) {
      this.taxonomies[code] = {
        code: code,
        title: title,
        links: {
          self: url,
          tree: url + '?drilldown=True'
        }
      };
    }
  }, {
    key: "loadTaxonomies",
    value: function () {
      var _loadTaxonomies = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(url) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.taxonomies = Object.assign({}, this.taxonomies);
                _context.next = 3;
                return axios.get(url).then(function (resp) {
                  resp.data.forEach(function (x) {
                    _this.taxonomies[x.code] = x;
                  });
                }).catch(function (err) {
                  console.log(err);
                });

              case 3:
                return _context.abrupt("return", this.taxonomies);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadTaxonomies(_x) {
        return _loadTaxonomies.apply(this, arguments);
      }

      return loadTaxonomies;
    }()
  }, {
    key: "addViewer",
    value: function addViewer(code, viewer) {
      this.viewers[code] = viewer;
    }
  }, {
    key: "addEditor",
    value: function addEditor(code, editor) {
      this.editors[code] = editor;
    }
  }]);

  return Taxonomies;
}();

var VueTaxonomy = {
  install: function install(Vue) {
    Vue.component('taxonomy-editor', __vue_component__$2);
    Vue.component('dialog-taxonomy-input', __vue_component__$4);
    Vue.prototype.$taxonomies = new Taxonomies();
  }
};

export { __vue_component__$4 as DialogTaxonomyInput, __vue_component__$2 as TaxonomyEditor, VueTaxonomy };
